@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.address-factory-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;

  > div:first-child {
    flex: 1;
    min-width: 0;
  }

  .pickup-relay-info {
    div[class^='data'] {
      color: @ship-to--pickup-relay--text-color;
    }
    color: @ship-to--pickup-relay--text-color;
    font-size: 14px;
    line-height: 20px;
    span {
      font-size: 13px;
    }
    svg {
      transform: scale(0.5);
      color: @ship-to--pickup-relay--svg--text-color;
      fill: @ship-to--pickup-relay--svg--fill-color;
      width: 25px;
      height: 25px;
      margin: 0 0 0 -7px;
      top: 8px;
      position: relative;
    }
  }
}
